import ScheduleGrid from './scheduleGrid';

export default ScheduleGrid;